import { type TrendEvent } from '../../api/client';
import { formatSignedNumber, formatSignedRub } from '../../lib/reportFormat';

const rubFmt = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  maximumFractionDigits: 0,
});

function formatRub(v: number | null | undefined): string {
  return v == null ? '—' : rubFmt.format(v);
}

function formatNumber(v: number | null | undefined): string {
  return v == null ? '—' : new Intl.NumberFormat('ru-RU').format(v);
}

function Row({
  label,
  current,
  previous,
  delta,
}: {
  label: string;
  current: string;
  previous: string;
  delta: string;
}) {
  return (
    <tr>
      <td>{label}</td>
      <td className="mono text-right">{current}</td>
      <td className="mono text-right">{previous}</td>
      <td className="mono text-right">{delta}</td>
    </tr>
  );
}

export function MetricsTable({ event }: { event: TrendEvent }) {
  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            <th>Метрика</th>
            <th className="text-right">Текущий месяц</th>
            <th className="text-right">Прошлый месяц</th>
            <th className="text-right">Изменение</th>
          </tr>
        </thead>
        <tbody>
          <Row
            label="Заказы, ₽"
            current={formatRub(event.revenue_current_rub)}
            previous={formatRub(event.revenue_previous_rub)}
            delta={formatSignedRub(event.revenue_delta_rub)}
          />
          <Row
            label="Заказы, шт."
            current={formatNumber(event.sales_current)}
            previous={formatNumber(event.sales_previous)}
            delta={formatSignedNumber(event.sales_delta)}
          />
          <Row
            label="Цена"
            current={formatRub(event.final_price_current)}
            previous={formatRub(event.final_price_previous)}
            delta={formatSignedRub(event.price_delta)}
          />
          <Row
            label="Отзывы"
            current={formatNumber(event.comments_current)}
            previous={formatNumber(event.comments_previous)}
            delta={formatSignedNumber(event.comments_delta)}
          />
          <Row
            label="Остатки"
            current={formatNumber(event.balance_current)}
            previous={formatNumber(event.balance_previous)}
            delta={formatSignedNumber(event.balance_delta)}
          />
        </tbody>
      </table>
    </div>
  );
}
